<template>
  <div class="wrapper wrapper-content p-0 animated fadeInUp">
    <div class="ibox-body">
      <!-- Header with add icon -->
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>{{ $t("navigations.arm list") }}</h5>
         <div class="position-relative align-self-center">
        <img src="@/assets/img/create.png"  width="17" alt="Add Arm" style="cursor: pointer;" @click="addNewRow" />
        <div class="tool-tip mt-2">Add Arm</div>
      </div>
    </div>
      <div class="ibox-content">
       
        <div>
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Arm Code
                    <!-- <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span> -->
                    <sup><i class="fa fa-asterisk required"></i></sup>
                  </th>
                  <th>Arm Name
                    <!-- <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span> -->
                    <sup><i class="fa fa-asterisk required"></i></sup>
                  </th>
                  <th>Arm Type
                    <!-- <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span> -->
                  </th>
                  <th>Description
                  </th>
                    <th>SoA ID
                  </th>
                  <th class="text-center sticky-column">Edit</th>
                  <th class="text-center">Delete</th>
                </tr>
              </thead>
              <tbody>
                <!-- New Row for creation -->
                <tr v-if="isAddingNew">
                  <td>
                    <input v-model="newRow.armCode" class="form-control" type="text"
                      @input="clearNewFieldError('armCode')" />
                    <div v-if="newRowErrors.armCode" class="text-danger">{{ newRowErrors.armCode }}</div>
                  </td>
                  <td>
                    <input v-model="newRow.armName" class="form-control" type="text"
                      @input="clearNewFieldError('armName')" />
                    <div v-if="newRowErrors.armName" class="text-danger">{{ newRowErrors.armName }}</div>
                  </td>
                  <td>
                    <input v-model="newRow.armType" class="form-control" type="text" />
                  </td>
                  <td>
                    <textarea v-model="newRow.description" class="form-control" rows="3"></textarea>
                  </td>
                  <td>
                    <input v-model="newRow.soaId" class="form-control" type="text" /> 
                  </td>
                  <td class="text-center sticky-column">
                    <i class="fa fa-check action-icon text-success" @click="saveNewRow" title="Save"></i>
                    <i class="fa fa-times action-icon text-danger" @click="cancelNewRow" title="Cancel"></i>
                  </td>
                  <td></td>
                </tr>
                    <!-- No data row -->
              <tr v-if="!isAddingNew && arms.length === 0">
                <td colspan="9" class="text-center">No data available.</td>
              </tr>
                <tr v-for="(arm, index) in arms" :key="arm.armId">
                  <!-- Arm Code -->
                  <td v-if="editIndex !== index">{{ arm.armCode }}</td>
                  <td v-else>
                    <input v-model="editableRow.armCode" class="form-control" type="text"
                      @input="clearFieldError('armCode')" />
                    <div v-if="validationErrors.armCode" class="text-danger">{{ validationErrors.armCode }}</div>
                  </td>
                  <!-- Arm Name -->
                  <td v-if="editIndex !== index">{{ arm.armName }}</td>
                  <td v-else>
                    <input v-model="editableRow.armName" class="form-control" type="text"
                      @input="clearFieldError('armName')" />
                    <div v-if="validationErrors.armName" class="text-danger">{{ validationErrors.armName }}</div>
                  </td>
                  <!-- Arm Type -->
                  <td v-if="editIndex !== index">{{ arm.armType }}</td>
                  <td v-else>
                    <input v-model="editableRow.armType" class="form-control" type="text"
                      @input="clearFieldError('armType')" />


                  </td>
                  <!-- Description -->
                  <td v-if="editIndex !== index">
                    <div class="wrap-text">{{ arm.description }}</div>
                  </td>
                  <td v-else>
                    <textarea v-model="editableRow.description" class="form-control" rows="3"></textarea>
                  </td>
                  <!-- SoA ID -->
                  <td v-if="editIndex !== index">{{ arm.soaId }}</td>
                  <td v-else>
                    <input v-model="editableRow.soaId" class="form-control" type="text"
                      @input="clearFieldError('soaId')" />
                  </td>
                  <!-- Edit Actions -->
                  <td class="text-center sticky-column">
                    <template v-if="editIndex !== index">
                      <i class="fa fa-edit edit-delete" v-if="protocol.status !== 'Generated'"
                        @click.prevent="editRow(index, arm)"></i>
                    </template>
                    <template v-else>
                      <i class="fa fa-check action-icon text-success" @click="updateRow(arm.id)" title="Update"></i>
                      <i class="fa fa-times action-icon text-danger" @click="cancelEdit" title="Cancel"></i>
                    </template>
                  </td>
                  <!-- Delete -->
                  <td class="text-center">
                    <i class="fa fa-trash edit-delete" v-if="protocol.status !== 'Generated'" style="color: #a13b7c"
                      @click="deleteRow(arm.id)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Pagination -->
          <div class="row mx-0">
            <div class="col-lg-12 mx-0 px-0">
              <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <v-pagination v-model="currentPage" :pages="totalPages" :range-size="0" active-color="#618bd7"
                    @update:modelValue="loadPage" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.action-icon {
  cursor: pointer;
  font-size: 18px;
  margin: 0 5px;
}

.action-icon:hover {
  opacity: 0.8;
}

.text-success {
  color: #28a745;
}

.text-danger {
  color: #dc3545;
}

.wrap-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 200px;
  overflow: hidden;
}

textarea.form-control {
  resize: vertical;
  max-height: 150px;
}

.sticky-column {
  position: sticky;
  right: 0;
  background-color: #fff;
  z-index: 10;
  border-left: 1px solid #dee2e6;
}
.position-relative .tool-tip {  
  right: 20px;
  top: 0px;
}
</style>

<script src="./ArmManagement.js"></script>